import { host, token } from '../API';

export const getAppBenchmarkList = async function (app: string) {
    const endpoint = host + "api/benchmark/global/" + app;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve benchmark list. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}